import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-12px" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "underline text-red-lp-400 font-semibold" }, "Customer Service", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onSubmit: _ctx.onSubmit,
        title: _ctx.$t('Permintaan Gagal !'),
        image: "image-modal-warning",
        textSuccess: _ctx.$t('booking.successOk'),
        class: "px-8"
      }, {
        custom: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.$t("booking.errorNotAllowEditBeforeCs")) + " ", 1),
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("booking.errorNotAllowEditAfterCs")), 1)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "title", "textSuccess"]))
    : _createCommentVNode("", true)
}